import React, { ReactNode } from 'react';
import styled from 'styled-components';
import './style/style.css';

interface DashBoardTempleteProps {
  title: string;
  children: ReactNode;
}

const DashBoardTemplete = ({ title, children }: DashBoardTempleteProps) => {
  return (
    <Container>
      <Header>
        <Title>{title}</Title>
      </Header>
      <Body>{children}</Body>
    </Container>
  );
};

export default DashBoardTemplete;

const Container = styled.div`
  background-color: #fff;
  height: 300px;
  box-sizing: border-box;
  display: flex;
  box-shadow: 1px 2px 10px -3px rgba(0, 0, 0, 0.25);
  flex-direction: column;
  * {
    box-sizing: border-box;
  }
`;

const Header = styled.div``;

const Title = styled.div`
  color: #000;
  font-weight: bold;
  font-size: 16px;
  padding-top: 10px;
  padding-left: 10px;
`;

const Body = styled.div`
  flex: 1;
`;
